var trim = function trim(str) {
  var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
  return str.replace(new RegExp("^\\".concat(symbol, "+|\\").concat(symbol, "+$"), 'g'), '');
};

export { trim as default };
//# sourceMappingURL=index.js.map
